import { render, staticRenderFns } from "./UpdateModels.vue?vue&type=template&id=2ed04b4c&"
import script from "./UpdateModels.vue?vue&type=script&lang=js&"
export * from "./UpdateModels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports